var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"inline-flex items-center justify-center rounded-xl py-0.5 capitalize",class:[_vm.colorStyles, _vm.sizeStyles]},[_vm._t("default"),_vm._v("\n    "+_vm._s(_vm.text)+"\n")],2)}
var staticRenderFns = []

export { render, staticRenderFns }